import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'image-item',
  templateUrl: './image-item.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImageItem implements OnInit {
  @Input() item$: Object;
  constructor(){ }

  ngOnInit(){
  }

}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/image-item/image-item.component.ts